document.addEventListener("DOMContentLoaded", () => {
  let observer = new MutationObserver((mutationsList, observer) => {
    let form = document.querySelector("form-embed");

    if (form) {
      observer.disconnect();
      let shadow = form.shadowRoot;

      let sheet = new CSSStyleSheet();
      sheet.insertRule(`
        fieldset legend{
          font-size: 17px !important;
          font-weight: 800 !important;
          letter-spacing: 0.5px !important;
          padding: 15px 0px !important;
          margin: 0 !important;
          font-family: var(--heading-font) !important; 
        }
      `);
      sheet.insertRule(`
        section._formContainer_stahb_30._grid_stahb_148._noImage_stahb_161{
              max-width: 60% !important;
        }
      `);
      sheet.insertRule(`
        button._formSubmitButton_1nihh_77{
          width: 50%;
          margin: 0 auto;
          background: #043b0c;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 1.1px;
          font-family: "Roboto Condensed", sans-serif;
        }
      `);
      shadow.adoptedStyleSheets.push(sheet);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
$(document).on("click", ".slideshow__media[data-url]", function () {
  const url = $(this).data("url");
  if (url && url.length > 0) {
    window.location.href = url;
  }
});
